import authService from "../Services/Login/LoginService";
import { store } from "../Redux/Store";
import { userlogout } from "../Redux/Slice/Auth/AuthSlice";

export async function performLogout(navigate) {
    const state = store.getState();
    const token = state.auth?.user?.data?.body?.data?.token;

    try {
        if (token) {
            await authService.logout(token);
        }
    } catch (error) {
        console.error("Logout API error:", error);
    }

    store.dispatch(userlogout());
    localStorage.clear();

    if (navigate) {
        navigate("/");
    }
}
